// src/pages/AboutPage/aboutContentStore.js

/**
 * AboutContentStore
 * - Today: returns DEFAULT_ABOUT_CONTENT (local).
 * - Later: replace with DB/API fetch, return the same shape.
 */

export class AboutContentStore {
  constructor({ source = "local" } = {}) {
    this.source = source;
  }

  async getAboutPageContent() {
    if (this.source === "local") return DEFAULT_ABOUT_CONTENT;

    // Future: fetch from DB/API here
    // Example:
    // const res = await fetch("/api/about");
    // return await res.json();

    throw new Error(`Unknown about content source: ${this.source}`);
  }
}

export const DEFAULT_ABOUT_CONTENT = {
  pageTitle: "About Okul",
  pageSubtitle: "A smarter way to learn in an AI-driven world",
  heroKicker: "Highlights",

  heroSlides: [
        {
      id: "s3",
      imageUrl:
        "https://images.unsplash.com/photo-1531498860502-7c67cf02f657?auto=format&fit=crop&w=1800&q=80",
      alt: "Technology and education",
      kicker: "Built for the future",
      headline: "AI that supports learning",
      subtext: "Built to guide learners and empower them for the future.",
      ctaLabel: "Read more",
      ctaAction: "scrollNext",
    },
    {
      id: "s1",
      imageUrl:
        "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1800&q=80",
      alt: "Students learning together",
      kicker: "Feedback-first",
      headline: "Practice. Feedback. Progress.",
      subtext: "Smart sessions with feedback that show what to improve",
      ctaLabel: "Read more",
      ctaAction: "scrollNext",
    },
    {
      id: "s2",
      imageUrl:
        "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=1800&q=80",
      alt: "Teacher explaining concepts",
      kicker: "Skills That Matter",
      headline: "Practice for Future Skills.",
      subtext: "English fluency, interview confidence, and a strong STEM foundation.",
      ctaLabel: "Read more",
      ctaAction: "scrollNext",
    },
  ],

  // Floating icons (light theme accents)
  // Replace later with DB-configured positions or randomize.
  floatingIcons: [
    { id: "i1", symbol: "∑", label: "Math", variant: "math", x: 6, y: 18, size: "md", delay: 0.2, duration: 9, opacity: 0.35 },
    { id: "i2", symbol: "⚛", label: "Science", variant: "sci", x: 18, y: 70, size: "sm", delay: 1.1, duration: 10, opacity: 0.32 },
    { id: "i3", symbol: "🧪", label: "Lab", variant: "lab", x: 40, y: 14, size: "sm", delay: 0.6, duration: 8, opacity: 0.30 },
    { id: "i4", symbol: "⌁", label: "Logic", variant: "tech", x: 62, y: 76, size: "md", delay: 1.6, duration: 11, opacity: 0.30 },
    { id: "i5", symbol: "π", label: "Math", variant: "math", x: 82, y: 20, size: "sm", delay: 0.9, duration: 9, opacity: 0.28 },
    { id: "i6", symbol: "✦", label: "Ideas", variant: "astro", x: 92, y: 62, size: "sm", delay: 2.0, duration: 12, opacity: 0.26 },
  ],

  whatIs: {
    title: "How to Contact us?",
    lede: "Email 📧: kumarniraj35948@gmail.com  & Phone 📞: +91 - 9661043440",
    paragraphs: [
    ],
  },

  beliefs: {
    title: null,
    items: null,
  },

  howItWorks: {
    title: "How learning happens on Okul",
    steps: [
      { id: "h1", heading: "Practice in short sessions", text: "Keep it lightweight and repeatable." },
      { id: "h2", heading: "Get instant detailed feedback", text: "Not just right/wrong — what to improve next." },
      { id: "h3", heading: "Track your progress", text: "See patterns, strengths, and weak areas." },
      { id: "h4", heading: "Build confidence", text: "Confidence comes from consistency." },
      { id: "h5", heading: "Prepare for AI ready world", text: "A new way of learning for a skill-driven world." },
    ],
  },

  stats: {
    title: null,
    items: null,
  },

  closing: {
    title: "We’re building for the next generation of learners",
    text:
      "Okul is built to make learning approachable and measurable. As we grow, we’ll keep focusing on clarity, accessibility, and meaningful feedback.",
    actions: [
      { id: "a1", label: "Explore Pricing", variant: "primary" },
      { id: "a2", label: "Contact", variant: "ghost" },
    ],
  },

  footerNote: "For any complaints / queries / suggestions contact at : kumarniraj35948@gmail.com or +91-9661043440",
};
